import React from "react";
import { Siren } from "lucide-react";
import { translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function EmergencyStrip() {
  const { lang } = useLang();
  const T = translations[lang];
  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-red-600 text-white">
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-9 flex items-center justify-center gap-2 text-center">
        <Siren className="h-4 w-4 shrink-0" />
        <p className="text-[12px] md:text-sm font-semibold tracking-wide">{T.emergency}</p>
      </div>
    </div>
  );
}
